var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 72,
    viewBox: "0 0 138 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 136,
    height: 70,
    rx: 35,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 136,
    height: 70,
    rx: 35,
    stroke: "#7B79A2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.2812 18.4375V32.1875H68.1016V34.7656H62.2812V53.2422H59.2344V18.4375H62.2812ZM53.1406 21.8359V24.375H39.9766V41.9531C46.2656 41.9531 50.7188 41.6602 55.875 40.7031L56.2656 43.3594C50.8359 44.3359 46.2656 44.5312 39.6641 44.5312H36.9297V21.8359H53.1406ZM85.7969 19.2188C93.3359 19.2188 98.0625 21.6406 98.0625 25.8203C98.0625 29.9219 93.3359 32.3047 85.7969 32.3047C78.2578 32.3047 73.4922 29.9219 73.4922 25.8203C73.4922 21.6406 78.2578 19.2188 85.7969 19.2188ZM85.7969 21.6797C80.1719 21.6797 76.6172 23.2422 76.6562 25.8203C76.6172 28.3594 80.1719 29.8438 85.7969 29.8828C91.3438 29.8438 94.9375 28.3594 94.9375 25.8203C94.9375 23.2422 91.3438 21.6797 85.7969 21.6797ZM97.75 41.2891V52.6953H73.8438V41.2891H97.75ZM76.8906 43.75V50.1953H94.7422V43.75H76.8906ZM101.617 35.3125V37.8516H69.9766V35.3125H101.617Z",
    fill: "#7B79A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextButton);
export default __webpack_public_path__ + "static/media/NextButton.92ac68714a0a9573c018a347c028fb55.svg";
export { ForwardRef as ReactComponent };